import GenericModal from '~/components/common/GenericModal';
import { useTranslation } from 'react-i18next';
import RequestDatepickerComponent from '~/components/pages/office/RequestDatepickerComponent';
import { CoreOfficeDataType } from '~/types/offices';
import { dateTimeOrStringToDate } from '~/components/utils/date';

declare const bootstrap: any;

type TProps = {
  office: CoreOfficeDataType;
  selectedStartDate?: Date;
  selectedEndDate?: Date;
  clear: () => void;
  apply: (start: Date, end: Date) => void;
  modalRef: React.RefObject<HTMLDivElement>;
};

const RequestDatepickerModal = ({ office, selectedStartDate, selectedEndDate, clear, apply, modalRef }: TProps) => {
  const { t } = useTranslation();
  const earliestStartDate = new Date(office.earliestStartDate);
  const today = new Date();

  // const modalIsOpen = datepickerModalRef.current?.classList.contains('show');
  // console.log("modalIsOpen:", modalIsOpen);

  return (
    <>
      <GenericModal
        open={true}
        modalRef={modalRef}
        title={t('global.btns.back')}
        id="requestDatePicker"
        variantBack={true}
        extraClasses="modal-md"
      >
        <RequestDatepickerComponent
          earliestStart={earliestStartDate < today ? today : earliestStartDate}
          latestEndOffice={
            office.lastAvailabilityDate === null ? undefined : dateTimeOrStringToDate(office.lastAvailabilityDate)
          }
          minDuration={office.minDuration}
          maxDuration={office.maxDuration}
          monthsShown={1}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
          clear={clear}
          apply={(start, end) => {
            const modal = bootstrap.Modal.getOrCreateInstance(modalRef.current);
            modal?.hide();
            apply(start, end);
          }}
        />
      </GenericModal>
    </>
  );
};

export default RequestDatepickerModal;
